import { IEmojiList } from '../../../interface'
import { EMOJI_TYPE } from '../../../constant'
import { emojiConfig } from './emoji-config'
export const basicEmojiUrl = emojiConfig.emojiBaseUrl
export const basicEmojiMap = emojiConfig.emojiUrlMapping
export const basicEmojiList = emojiConfig.emojiNameMapping
export const basicEmojiKey = emojiConfig.emojiKeyMapping
export const bigEmojiUrl = 'https://web.sdk.qcloud.com/im/assets/face-elem/'

export const bigEmojiList: Array<any> = [
  {
    type: 'blkbig',
    index: 4,
    url: 'https://www.bio-cloud.com.cn:8022/img/2023-03-20/156C7EDA-15DE-DD54-1818-B845B202D788.png',
    list: ['01-就这么拌.jpg', '02-hello我来啦.jpg', '04-达成一致.jpg', '05-OK.jpg', '06-谢谢.jpg', '07-加油.jpg', '09-我顶得住.jpg', '10-努力工作.jpg',
      '12-效率起飞.jpg', '13-加载中.jpg', '14-你细品.jpg', '15-安全供货.jpg', '乘风破浪.jpg', '果断出手.jpg', '收到.jpg', '我膨胀了.jpg']
  },
  {
    type: EMOJI_TYPE.BIG,
    index: 1,
    url: bigEmojiUrl,
    list: ['yz00', 'yz01', 'yz02', 'yz03', 'yz04', 'yz05', 'yz06', 'yz07', 'yz08',
      'yz09', 'yz10', 'yz11', 'yz12', 'yz13', 'yz14', 'yz15', 'yz16', 'yz17']
  },
  {
    type: EMOJI_TYPE.BIG,
    index: 2,
    url: bigEmojiUrl,
    list: ['ys00', 'ys01', 'ys02', 'ys03', 'ys04', 'ys05', 'ys06', 'ys07', 'ys08',
      'ys09', 'ys10', 'ys11', 'ys12', 'ys13', 'ys14', 'ys15']
  },
  {
    type: EMOJI_TYPE.BIG,
    index: 3,
    url: bigEmojiUrl,
    list: ['gcs00', 'gcs01', 'gcs02', 'gcs03', 'gcs04', 'gcs05', 'gcs06', 'gcs07',
      'gcs08', 'gcs09', 'gcs10', 'gcs11', 'gcs12', 'gcs13', 'gcs14', 'gcs15', 'gcs16']
  }
]

export const emojiList: IEmojiList = [
  {
    type: EMOJI_TYPE.BASIC,
    url: basicEmojiUrl,
    list: Object.keys(basicEmojiList)
  },
  ...bigEmojiList
]

export const decodeTextMessage = (text: string) => {
  if (!text) {
    return ''
  }
  // return decodeText(text)
  const reg = /(\[.+?\])/g
  let txt: string = text
  if (reg.test(text)) {
    txt = text.replace(reg, match => basicEmojiList[match] || match)
  }
  return txt
}

// 把中文的 value [微笑] 转化为英文的 key [TUIEmoji_Smile]
export const transformEmojiValueToKey = (text: string) => {
  if (!text) {
    return ''
  }
  const reg = /(\[.+?\])/g
  let txt: string = text
  if (reg.test(text)) {
    txt = text.replace(reg, match => basicEmojiKey[match] || match)
  }
  return txt
}
